module.exports = __webpack_public_path__ + "img/residencial_mx_offline.6d72d3c4.png";